/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faUser, faHistory, faContactBook, faMessage, faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import UserProfile from "cruds/user-profile";
import RoleManagement from "cruds/role-managament";
import CompanyManagement from "cruds/company-management";
import TagManagement from "cruds/tag-management";
import UserManagement from "cruds/user-management";
import ItemManagement from "cruds/item-management";
import EntityManagement from "cruds/entity-management";

// Material Dashboard 2 PRO React components
import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import profilePicture from "assets/images/team-3.jpg";
import EventLogManagement from "cruds/eventlog-management";
import InternalDeviceManagement from "cruds/device-management/internal-device-management";
import ContactManagement from "cruds/contact-management";
import APIManagement from "cruds/api-management";
import ExternalDeviceManagement from "cruds/device-management/external-device-management";
import MonitorManagement from "cruds/device-management/monitor-management";
import ExternalParameterManagement from "cruds/api/mapping";
import InternalParameterManagement from "cruds/api/mapping/internal-parameter";
import MessageTemplate from "cruds/message-management";
import AlertManagement from "cruds/alert";
import ProviderManagement from "cruds/provider-management";
import MapDeviceManagement from "cruds/device-management/internal-device-management/map-device";
import ServiceRequestManagement from "cruds/servicerequest-management";
import RivioWebHookManagement from "cruds/riviowebhook-management";
import CronLog from "cruds/cronlog-management";
import StorageManagement from "cruds/storage-management";
import CampaignList from "cruds/campaign/campaigns";
import CampaignCompanyList from "cruds/campaign/Company";
import CampaignEventList from "cruds/campaign/events";
import CampaignContactList from "cruds/campaign/contacts";
import CampaignDashboard from "cruds/campaign/dashboard";
import PromptTemplate from "cruds/prompt-template";
import CampaignTemplateList from "cruds/campaign/template";
import Batch from "cruds/campaign/batch";
import CampaignAssociationList from "cruds/campaign/association";
import GeofenceManager from "cruds/geofence-management";
import RouteTemplates from "cruds/route-template";
import Routes from "cruds/routes";
import SubscriptionPlan from "cruds/subscription-plan";
import SubscriptionList from "cruds/subscription-plan/subscription-list";
import QueueList from "cruds/device-management/queue-list";
import ContactDeviceAccess from "cruds/contact-device-access";
import Onboarding from "cruds/onboarding";
import Dashboard2 from "cruds/dashboard-2";
import CustomerBillingPage from "layouts/pages/account/billing/CustomerBillingPage";
import CustomerInvoiceDetail from "layouts/pages/account/invoice/CustomerInvoiceDetail";

const routes = [
  {
    type: "collapse",
    name: "Bruce Mars",
    key: "user-name",
    icon: <MDAvatar src={profilePicture} alt="Bruce Mars" size="sm" />,
    collapse: [
      {
        name: "My Profile",
        key: "user-profile",
        route: "/user-profile",
        component: <UserProfile />,
      },
      // {
      //   name: "My Profile",
      //   key: "profile-overview",
      //   route: "/pages/profile/profile-overview",
      //   component: <ProfileOverview />,
      // },
      // {
      //   name: "Settings",
      //   key: "settings",
      //   route: "/pages/account/settings",
      //   component: <Settings />,
      // },
      {
        name: "Logout",
        key: "logout",
      },
    ],
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Setup",
    key: "setup",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    collapse: [
      {
        name: "Alert",
        icon: <FontAwesomeIcon icon={faMessage} size="sm" />,
        key: "alert-management",
        route: "/alert-management",
        component: <AlertManagement />,
      },
      {
        name: "API",
        key: "api-management",
        collapse: [
          {
            name: "API Credentials",
            key: "apiCredentials",
            route: "/api-management",
            component: <APIManagement />,
            type: "apis",
          },
          {
            name: "External Parameters",
            key: "external-paramter-management",
            route: "/external-paramter-management",
            component: <ExternalParameterManagement />,
            type: "apis",
          },
          {
            name: "Internal Parameters",
            key: "internal-parameter-management",
            route: "/internal-parameter-management",
            component: <InternalParameterManagement />,
            type: "apis",
          },
        ],
        type: "apis"
      },
      {
        name: "Campaigns",
        key: "campaign",
        collapse: [
          {
            name: 'Overview',
            key: 'campaign-overview',
            collapse: [
              {
                name: "Dashboard",
                key: "campaign-dashboard",
                route: "/campaign/dashboard",
                component: <CampaignDashboard />,
                type: "campaign",
              },
              // {
              //   name: "Job Queue",
              //   key: "campaign-jon-queue",
              //   route: "/campaign/jobqueue",
              //   component: <CampaignJobQueue />,
              //   type: "campaign",
              // },
              // {
              //   name: "Job Queue Testing",
              //   key: "campaign-jon-queue-testing",
              //   route: "/campaign/jobqueue-testing",
              //   component: <CampaignJobQueueTesting />,
              //   type: "campaign",
              // },
              {
                name: "Job Batch",
                key: "batch",
                route: "/campaign/batch",
                component: <Batch />,
                type: "campaign",
              },
              {
                name: "Active Campaign",
                key: "active-campaign",
                route: "/campaign/active",
                component: <CampaignList />,
                type: "campaign",
              },
              {
                name: "Completed Campaign",
                key: "complete-campaign",
                route: "/campaign/compete",
                component: <CampaignList />,
                type: "campaign",
              },
            ],
            type: "campaign",
          },
          {
            name: 'Setup',
            key: 'campaign-setup',
            collapse: [
              {
                name: "Campaign List",
                key: "campaign-list",
                route: "/campaign",
                component: <CampaignList />,
                type: "campaign", 
              },
              {
                name: "Campaign Company",
                key: "company-list",
                route: "/campaign/company",
                component: <CampaignCompanyList />,
                type: "campaign", 
              },
              {
                name: "Campaign Contact",
                key: "contact-list",
                route: "/campaign/contact",
                component: <CampaignContactList />,
                type: "campaign", 
              },
              {
                name: "Campaign Event",
                key: "event-list",
                route: "/campaign/event",
                component: <CampaignEventList />,
                type: "campaign", 
              },
              {
                name: "Campaign Template",
                key: "template-list", 
                route: "/campaign/template",
                component: <CampaignTemplateList />,
                type: "campaign",
              },
              {
                name: "Campaign Association",
                key: "association-list", 
                route: "/campaign/association",
                component: <CampaignAssociationList />,
                type: "campaign",
              },
            ],
            type: "campaign",
          }
        ],
        type: "campaign",
      },
      {
        name: "Companies",
        key: "company-management",
        route: "/company-management",
        component: <CompanyManagement />,
        type: "companies",
      },
      {
        type: "contacts",
        name: "Contacts",
        icon: <FontAwesomeIcon icon={faContactBook} size="sm" />,
        key: "contact-management",
        route: "/contact-management",
        component: <ContactManagement />,
      },
      {
        name: "Devices",
        key: "internal-device-management",
        collapse: [
          {
            name: "Internal Devices",
            key: "internal-devices",
            route: "/devices",
            component: <InternalDeviceManagement />,
            type: "devices",
          },
          {
            name: "External Devices",
            key: "external-devices",
            route: "/external-device-management",
            component: <ExternalDeviceManagement />,
            type: "externaldevices",
          },
          {
            name: "Monitor",
            key: "monitors",
            route: "/monitor-management",
            component: <MonitorManagement />,
            type: "monitors",
          },
          {
            name: "QueueList",
            key: "monitors",
            route: "/queue-list",
            component: <QueueList />,
            type: "monitors",
          },
        ],
        type: "devices"
      },
      // {
      //   type: "entities",
      //   name: "Entities",
      //   key: "entity-management",
      //   icon: <FontAwesomeIcon icon={faInfo} size="sm" />,
      //   route: "/entity-management",
      //   component: <EntityManagement />,
      // },
      {
        name: "Items",
        key: "item-management",
        route: "/item-management",
        component: <ItemManagement />,
        type: "items",
      },
      {
        name: "Logs",
        key: "log-management",
        collapse: [
          {
            name: "Cron Logs",
            icon: <FontAwesomeIcon icon={faHistory} size="sm" />,
            key: "cron-log-management",
            route: "/logs/cron",
            component: <CronLog />,
            type: "cronlogs",
          },
          {
            name: "Event Logs",
            icon: <FontAwesomeIcon icon={faHistory} size="sm" />,
            key: "eventlog-management",
            route: "/logs/event",
            component: <EventLogManagement />,
            type: "eventlogs",
          },
          // {
          //   name: "Job Logs",
          //   icon: <FontAwesomeIcon icon={faHistory} size="sm" />,
          //   key: "campaign-job-logs",
          //   route: "/logs/job",
          //   component: <JobLogs />,
          //   type: "campaign",
          // },
          {
            name: "Webhooks Logs",
            icon: <FontAwesomeIcon icon={faHistory} size="sm" />,
            key: "webhook-management",
            route: "/logs/webhooks",
            component: <RivioWebHookManagement />,
            type: "webhooklogs",
          },
        ],
        type: "cronlogs"
      },
      {
        name: "Templates",
        key: "template-management",
        collapse: [
          {
            name: "Message Template",
            icon: <FontAwesomeIcon icon={faMessage} size="sm" />,
            key: "message-management",
            route: "/message-management",
            component: <MessageTemplate />,
            type: "messagetempates",
          },
          {
            name: "Prompt Template",
            icon: <FontAwesomeIcon icon={faMessage} size="sm" />,
            key: "prompt-management",
            route: "/prompt-template",
            component: <PromptTemplate />,
            type: "prompt",
          },
        ],
        type: "messagetempates"
      },
      {
        type: "providers",
        icon: <FontAwesomeIcon icon={faUser} size="sm" />,
        name: "Provider",
        key: "provider-management",
        route: "/provider-management",
        component: <ProviderManagement />,
        noCollapse: true,
      },
      {
        name: "Roles",
        key: "role-management",
        route: "/role-management",
        component: <RoleManagement />,
        type: "roles",
      },
      {
        name: "Storage",
        key: "storage-management",
        route: "/storage-management",
        component: <StorageManagement />,
        type: "storage",
      },
      {
        name: "Users",
        key: "user-management",
        route: "/user-management",
        component: <UserManagement />,
        type: "users",
      },
      {
        name: "Tag Management",
        key: "tag-management",
        route: "/tag-management",
        component: <TagManagement />,
        type: "tags",
      },
    ]
  },
  { type: "divider", key: "divider-1" },
  {
    type: "collapse",
    name: "Device Dashboard",
    route: "/device-dashboard",
    component: <MapDeviceManagement />,
    key: "device-dashboard",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Dashboard 2",
    route: "/device-dashboard-2",
    component: <Dashboard2 />,
    key: "device-dashboard-2",
    icon: <Icon fontSize="medium">dashboard_customize</Icon>,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Contact Item Access",
    route: "/contact-item-access",
    component: <ContactDeviceAccess />,
    key: "contact-item-access",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Routes",
    route: "/routes",
    component: <Routes />,
    key: "routes",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Route Templates",
    route: "/route-template",
    component: <RouteTemplates />,
    key: "route-template",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Geofences",
    route: "/geofence",
    component: <GeofenceManager />,
    key: "geofence",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Device List",
    route: "/device-list",
    component: <InternalDeviceManagement />,
    key: "device-list",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Entities",
    route: "/entity-list",
    component: <EntityManagement />,
    key: "entity-list",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Requests",
    route: "/service-request",
    component: <ServiceRequestManagement />,
    key: "service-request",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Plan",
    route: "/subscription-plan",
    component: <SubscriptionPlan />,
    key: "subscription-plan",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Subscription",
    route: "/subscription-list",
    component: <SubscriptionList />,
    key: "subscription-list",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Onboarding",
    route: "/onboarding",
    component: <Onboarding />,
    key: "onboarding",
    icon: <FontAwesomeIcon icon={faUser} size="sm" />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Billing",
    route: "/billing",
    component: <CustomerBillingPage />,
    key: "billing",
    icon: <FontAwesomeIcon icon={faMoneyBill} size="sm" />,
    noCollapse: true
  },
  // {
  //   type: "collapse",
  //   name: "Sim Card Management",
  //   route: "/sim-card-management",
  //   component: <OnomondoManagement />,
  //   key: "sim-card-management",
  //   icon: <FontAwesomeIcon icon={faUser} size="sm" />,
  //   noCollapse: true
  // },
  // {
  //   name: "SendGrid Activity",
  //   icon: <FontAwesomeIcon icon={faMessage} size="sm" />,
  //   key: "sendgrid-management",
  //   route: "/sendgrid-management",
  //   component: <SendGridManagement />,
  //   type: "collapse",
  //   noCollapse: true
  // },


  // { type: "divider", key: "divider-5" },
  // {
  //   type: "collapse",
  //   name: "Dashboards",
  //   key: "dashboards",
  //   icon: <Icon fontSize="medium">dashboard</Icon>,
  //   collapse: [
  //     {
  //       name: "Analytics",
  //       key: "analytics",
  //       route: "/dashboards/analytics",
  //       component: <Analytics />,
  //     },
  //     {
  //       name: "Sales",
  //       key: "sales",
  //       route: "/dashboards/sales",
  //       component: <Sales />,
  //     },
  //   ],
  // },
  // { type: "title", title: "Pages", key: "title-pages" },
  // {
  //   type: "collapse",
  //   name: "Pages",
  //   key: "pages",
  //   icon: <Icon fontSize="medium">image</Icon>,
  //   collapse: [
  //     {
  //       name: "Profile",
  //       key: "profile",
  //       collapse: [
  //         {
  //           name: "Profile Overview",
  //           key: "profile-overview",
  //           route: "/pages/profile/profile-overview",
  //           component: <ProfileOverview />,
  //         },
  //         {
  //           name: "All Projects",
  //           key: "all-projects",
  //           route: "/pages/profile/all-projects",
  //           component: <AllProjects />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Users",
  //       key: "users",
  //       collapse: [
  //         {
  //           name: "New User",
  //           key: "new-user",
  //           route: "/pages/users/new-user",
  //           component: <NewUser />,
  //         },
  //       ],
  //     },
  {
    name: "Account",
    key: "account",
    collapse: [
      // {
      //   name: "Settings",
      //   key: "settings",
      //   route: "/pages/account/settings",
      //   component: <Settings />,
      // },
      // {
      //   name: "Billing",
      //   key: "billing",
      //   route: "/billing",
      //   component: <CustomerBillingPage />,
      // },
      {
        name: "Invoice",
        key: "invoice",
        route: "/pages/account/invoice/:id",
        component: <CustomerInvoiceDetail />,
      },
    ],
  },
  //     {
  //       name: "Projects",
  //       key: "projects",
  //       collapse: [
  //         {
  //           name: "Timeline",
  //           key: "timeline",
  //           route: "/pages/projects/timeline",
  //           component: <Timeline />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Pricing Page",
  //       key: "pricing-page",
  //       route: "/pages/pricing-page",
  //       component: <PricingPage />,
  //     },
  //     { name: "RTL", key: "rtl", route: "/pages/rtl", component: <RTL /> },
  //     { name: "Widgets", key: "widgets", route: "/pages/widgets", component: <Widgets /> },
  //     { name: "Charts", key: "charts", route: "/pages/charts", component: <Charts /> },
  //     {
  //       name: "Notfications",
  //       key: "notifications",
  //       route: "/pages/notifications",
  //       component: <Notifications />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Applications",
  //   key: "applications",
  //   icon: <Icon fontSize="medium">apps</Icon>,
  //   collapse: [
  //     {
  //       name: "Kanban",
  //       key: "kanban",
  //       route: "/applications/kanban",
  //       component: <Kanban />,
  //     },
  //     {
  //       name: "Wizard",
  //       key: "wizard",
  //       route: "/applications/wizard",
  //       component: <Wizard />,
  //     },
  //     {
  //       name: "Data Tables",
  //       key: "data-tables",
  //       route: "/applications/data-tables",
  //       component: <DataTables />,
  //     },
  //     {
  //       name: "Calendar",
  //       key: "calendar",
  //       route: "/applications/calendar",
  //       component: <Calendar />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Ecommerce",
  //   key: "ecommerce",
  //   icon: <Icon fontSize="medium">shopping_basket</Icon>,
  //   collapse: [
  //     {
  //       name: "Products",
  //       key: "products",
  //       collapse: [
  //         {
  //           name: "New Product",
  //           key: "new-product",
  //           route: "/ecommerce/products/new-product",
  //           component: <NewProduct />,
  //         },
  //         {
  //           name: "Edit Product",
  //           key: "edit-product",
  //           route: "/ecommerce/products/edit-product",
  //           component: <EditProduct />,
  //         },
  //         {
  //           name: "Product Page",
  //           key: "product-page",
  //           route: "/ecommerce/products/product-page",
  //           component: <ProductPage />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Orders",
  //       key: "orders",
  //       collapse: [
  //         {
  //           name: "Order List",
  //           key: "order-list",
  //           route: "/ecommerce/orders/order-list",
  //           component: <OrderList />,
  //         },
  //         {
  //           name: "Order Details",
  //           key: "order-details",
  //           route: "/ecommerce/orders/order-details",
  //           component: <OrderDetails />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Authentication",
  //   key: "authentication",
  //   icon: <Icon fontSize="medium">content_paste</Icon>,
  //   collapse: [
  //     {
  //       name: "Sign In",
  //       key: "sign-in",
  //       collapse: [
  //         {
  //           name: "Basic",
  //           key: "basic",
  //           route: "/authentication/sign-in/basic",
  //           component: <SignInBasic />,
  //         },
  //         {
  //           name: "Cover",
  //           key: "cover",
  //           route: "/authentication/sign-in/cover",
  //           component: <SignInCover />,
  //         },
  //         {
  //           name: "Illustration",
  //           key: "illustration",
  //           route: "/authentication/sign-in/illustration",
  //           component: <SignInIllustration />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Sign Up",
  //       key: "sign-up",
  //       collapse: [
  //         {
  //           name: "Cover",
  //           key: "cover",
  //           route: "/authentication/sign-up/cover",
  //           component: <SignUpCover />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Reset Password",
  //       key: "reset-password",
  //       collapse: [
  //         {
  //           name: "Cover",
  //           key: "cover",
  //           route: "/authentication/reset-password/cover",
  //           component: <ResetCover />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // { type: "divider", key: "divider-6" },
  // { type: "title", title: "Docs", key: "title-docs" },
  // {
  //   type: "collapse",
  //   name: "Basic",
  //   key: "basic",
  //   icon: <Icon fontSize="medium">upcoming</Icon>,
  //   collapse: [
  //     {
  //       name: "Getting Started",
  //       key: "getting-started",
  //       collapse: [
  //         {
  //           name: "Overview",
  //           key: "overview",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/overview/material-dashboard/",
  //         },
  //         {
  //           name: "License",
  //           key: "license",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/license/material-dashboard/",
  //         },
  //         {
  //           name: "Quick Start",
  //           key: "quick-start",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/quick-start/material-dashboard/",
  //         },
  //         {
  //           name: "Build Tools",
  //           key: "build-tools",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/build-tools/material-dashboard/",
  //         },
  //       ],
  //     },
  //     {
  //       name: "Foundation",
  //       key: "foundation",
  //       collapse: [
  //         {
  //           name: "Colors",
  //           key: "colors",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/colors/material-dashboard/",
  //         },
  //         {
  //           name: "Grid",
  //           key: "grid",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/grid/material-dashboard/",
  //         },
  //         {
  //           name: "Typography",
  //           key: "base-typography",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/base-typography/material-dashboard/",
  //         },
  //         {
  //           name: "Borders",
  //           key: "borders",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/borders/material-dashboard/",
  //         },
  //         {
  //           name: "Box Shadows",
  //           key: "box-shadows",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/box-shadows/material-dashboard/",
  //         },
  //         {
  //           name: "Functions",
  //           key: "functions",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/functions/material-dashboard/",
  //         },
  //         {
  //           name: "Routing System",
  //           key: "routing-system",
  //           href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/routing-system/material-dashboard/",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Components",
  //   key: "components",
  //   icon: <Icon fontSize="medium">view_in_ar</Icon>,
  //   collapse: [
  //     {
  //       name: "Alerts",
  //       key: "alerts",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/alerts/material-dashboard/",
  //     },
  //     {
  //       name: "Avatar",
  //       key: "avatar",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/avatar/material-dashboard/",
  //     },
  //     {
  //       name: "Badge",
  //       key: "badge",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/badge/material-dashboard/",
  //     },
  //     {
  //       name: "Badge Dot",
  //       key: "badge-dot",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/badge-dot/material-dashboard/",
  //     },
  //     {
  //       name: "Box",
  //       key: "box",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/box/material-dashboard/",
  //     },
  //     {
  //       name: "Buttons",
  //       key: "buttons",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/buttons/material-dashboard/",
  //     },
  //     {
  //       name: "Date Picker",
  //       key: "date-picker",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/datepicker/material-dashboard/",
  //     },
  //     {
  //       name: "Dropzone",
  //       key: "dropzone",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/dropzone/material-dashboard/",
  //     },
  //     {
  //       name: "Editor",
  //       key: "editor",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/quill/material-dashboard/",
  //     },
  //     {
  //       name: "Input",
  //       key: "input",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/input/material-dashboard/",
  //     },
  //     {
  //       name: "Pagination",
  //       key: "pagination",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/pagination/material-dashboard/",
  //     },
  //     {
  //       name: "Progress",
  //       key: "progress",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/progress/material-dashboard/",
  //     },
  //     {
  //       name: "Snackbar",
  //       key: "snackbar",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/snackbar/material-dashboard/",
  //     },
  //     {
  //       name: "Social Button",
  //       key: "social-button",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/social-buttons/material-dashboard/",
  //     },
  //     {
  //       name: "Typography",
  //       key: "typography",
  //       href: "hhttps://material-dashboard-react-laravel-docs.creative-tim.com/react/typography/material-dashboard/",
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Change Log",
  //   key: "changelog",
  //   href: "https://github.com/creativetimofficial/ct-material-dashboard-pro-react/blob/main/CHANGELOG.md",
  //   icon: <Icon fontSize="medium">receipt_long</Icon>,
  //   noCollapse: true,
  // },
];

export default routes;
